module.exports = __webpack_public_path__ + "static/media/gridPlusWallet.3101eb1e.png";